import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M15 3.39a.74.74 0 0 1-.75.75h-1.06v1.09a.75.75 0 1 1-1.5 0V4.14H10.6a.75.75 0 0 1 0-1.5h1.09V1.56a.75.75 0 0 1 1.5 0v1.08h1.08a.75.75 0 0 1 .73.75ZM8.21 1.65a.66.66 0 0 0-.62-.25h-1a3.6 3.6 0 0 0-3.88 3.94v8.21a1.21 1.21 0 0 0 .68 1.13 1.13 1.13 0 0 0 .48.11 1.37 1.37 0 0 0 .86-.33c.18-.16 1.72-1.28 3.22-2.35 1.5 1.07 3 2.19 3.24 2.36a1.32 1.32 0 0 0 .84.32 1.16 1.16 0 0 0 .48-.11 1.21 1.21 0 0 0 .68-1.13V8.39a.75.75 0 0 0-.75-.75A4.27 4.27 0 0 1 8.2 3.4c-.01-.91.22-1.4.01-1.75Z';
const draw24px =
  'M22.29,4.78a.75.75,0,0,1-.75.75h-2v2a.75.75,0,0,1-1.5,0v-2H16A.75.75,0,0,1,16,4h2V2a.75.75,0,0,1,1.5,0V4h2A.74.74,0,0,1,22.29,4.78Zm-3.52,5.71a5.72,5.72,0,0,1-5.72-5.72,5.7,5.7,0,0,1,.28-1.86.76.76,0,0,0-.75-.75H10c-3.51,0-5.53,2-5.53,5.55v12.4a1.46,1.46,0,0,0,.81,1.37,1.24,1.24,0,0,0,.56.13,1.59,1.59,0,0,0,1-.41C7.2,20.92,10,18.9,12,17.45c2,1.45,4.77,3.43,5.09,3.72a1.63,1.63,0,0,0,1,.4,1.24,1.24,0,0,0,.56-.13,1.46,1.46,0,0,0,.81-1.37V11.24A.76.76,0,0,0,18.77,10.49Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const BookmarkAddFilledIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'bookmarkAddFilled')) as IconWithRender;

BookmarkAddFilledIcon.displayName = 'BookmarkAddFilledIcon';
BookmarkAddFilledIcon.propTypes = Icon.propTypes;
BookmarkAddFilledIcon.renderIcon = (props) => (
  <BookmarkAddFilledIcon {...props} />
);
export default BookmarkAddFilledIcon;
